import React, { Component, useState } from 'react';
import _ from 'lodash';
import PhoneNumber from '@/elements/inputs/PhoneNumber';
import Input from '@/elements/Input';
import ReduxContainer from '@/ReduxContainer';
import Segment from '@/utils/Segment';
import Alert from '@/components/Alert/Alert';
import { useCountries } from '@/hooks/useCountries';
import useCountryCodes from '@/hooks/auth/useCountryCodes';

const ChefFields = (props) => {
    const [postcodes, setPostcodes] = useState([]);
    const [phoneIsoUserOverride, setPhoneIsoUserOverride] = useState(false);
    const countries = useCountries();
    const { data: countryCodes } = useCountryCodes();
    const countryOptions = Object.values(countries).map((c) => ({
        label: `${c.flag ?? ''} ${c.name}`.trim(),
        value: c.iso_code,
    }));
    const postcodeLabel = props.formData.country === 'US' ? 'Zip code' : props.formData.country === 'GB' ? 'Postcode' : 'Postal code';

    let phoneError = _.get(props.errors, ['phone'][0]);
    const termsError = _.get(props.errors, ['terms-checkbox'][0]);

    if (phoneError && phoneError.length > 0) {
        phoneError = props.errors.phone[0];
    }

    const getPostcodes = (value) => {
        axios
            .get(route('postcode.autocomplete', { postcode: value }))
            .then((response) => {
                setPostcodes(response.data);
            })
            .catch((error) => {
                console.error('Postcode autocomplete error: ', error);
            });
    };

    const delayAutocomplete = _.debounce((value) => {
        getPostcodes(value);
    }, 300);

    return (
        <ReduxContainer>
            <Input
                inputType="select"
                label="Country"
                value={countryOptions.find(c => c.value === props.formData.country) || null}
                handleChange={(selected) => {
                    const value = selected?.value;
                    props.onChange(value, 'country');

                    if (!phoneIsoUserOverride && value && countryCodes) {
                        const match = countryCodes.find((c) => c.iso_code === value);
                        if (match?.phone_iso) {
                            props.onChange(match.phone_iso, 'phoneIso');
                        }
                    }
                }}
                options={countryOptions}
                error={props.errors.country}
                isSearchable={false}
                required
            />
            {!props.passedPhoneVerification && (
                <PhoneNumber
                    key={`phone-${props.formData.country}`}
                    errors={props.errors}
                    formData={props.formData}
                    onChange={(val, label) => {
                        if (label === 'phoneIso') {
                            setPhoneIsoUserOverride(true);
                        }
                        return props.onChange(val, label);
                    }}
                    label="Phone"
                    required={true}
                />
            )}
            <Input
                inputType="autocomplete"
                key={`postcode-${props.formData.country}`}
                label={postcodeLabel}
                placeholder={`Enter your ${postcodeLabel.toLowerCase()}...`}
                name="postcode"
                value={_.get(props.formData, ['postcode'])}
                options={props.formData.country === 'GB' ? postcodes : []}
                handleChange={(val) => {
                    props.onChange(val, 'postcode');
                    if (props.formData.country === 'GB') {
                        delayAutocomplete(val);
                    }
                }}
                onSelect={(val) => props.onChange(val, 'postcode')}
                error={props.errors?.postcode?.join(', ')}
                required
            />
            By signing up, I agree with Yhangry's{' '}
            <a
                target="_blank"
                href="https://yhangry.com/terms-and-conditions/"
                title="Terms of Service"
                className="form__link">
                Terms of Service
            </a>{' '}
            and{' '}
            <a
                target="_blank"
                href="https://yhangry.com/privacy-policy/"
                title="Privacy Policy"
                className="form__link">
                Privacy Policy
            </a>
            {/* </React.Fragment>
                }
                error={termsError}
                required
            /> */}
        </ReduxContainer>
    );
};

export default class CustomerRegister extends Component {
    componentDidMount() {
        // fire tracking event when someone hits the register step
        Segment.track('auth.register-step');
    }

    renderCaptchaResponse() {
        const error = _.get(this.props.errors, 'cf-turnstile-response');

        if (!error) return false;

        return error;
    }

    _togglePassword() {
        if ($('#password').attr('type') == 'password') {
            $('#password').attr('type', 'text');
        } else {
            $('#password').attr('type', 'password');
        }
    }

    render() {
        let phoneError = _.get(this.props.errors, ['phone'][0]);

        if (phoneError && phoneError.length > 0) {
            phoneError = this.props.errors.phone[0];
        }

        let fields = {
            firstName: 'First Name',
            lastName: 'Last Name',
            password: 'Password',
        };

        // if props.passedPhoneVerification is true, then add the email field to the fields list
        if (this.props.passedPhoneVerification) {
            fields = {
                ...fields,
                email: 'Email',
            };
        }

        return (
            <div>
                <form onSubmit={this.props.onSubmit} className="text-left">
                    <div className="form-group" key="auth-register-field-email">
                        <label>Email</label>
                        <p>{_.get(this.props.formData, 'email')}</p>
                    </div>

                    {_.map(fields, (label, key) => {
                        const error = _.get(this.props.errors, [key][0])?.join(
                            ', ',
                        );
                        return (
                            <Input
                                key={key}
                                id={key}
                                inputType={key}
                                placeholder={`Enter your ${label.toLowerCase()}...`}
                                label={label}
                                name={key}
                                value={_.get(this.props.formData, [key][0])}
                                autoComplete={key}
                                handleChange={(val) =>
                                    this.props.onChange(val, key)
                                }
                                inputClass={
                                    key == 'password' && 'password-input'
                                }
                                error={error}
                                required>
                                {key == 'password' && (
                                    <span
                                        className="show-password"
                                        onClick={this._togglePassword}>
                                        <i className="fa fa-eye icon"></i>
                                    </span>
                                )}
                            </Input>
                        );
                    })}

                    {this.props.type && this.props.type == 'chef' ? (
                        <ReduxContainer>
                            <ChefFields {...this.props} />
                        </ReduxContainer>
                    ) : (
                        <>
                            {!this.props.guestAccount && (
                                <>
                                    {!this.props.passedPhoneVerification && (
                                        <PhoneNumber
                                            errors={this.props.errors}
                                            formData={this.props.formData}
                                            onChange={this.props.onChange}
                                            label="Phone"
                                            required={true}
                                        />
                                    )}

                                    {/* <Input
                                        id="howDidYouFindOutAboutUs"
                                        name="howDidYouFindOutAboutUs"
                                        label="How did you find out about us?"
                                        value={
                                            this.props.formData
                                                .howDidYouFindOutAboutUs
                                        }
                                        handleChange={(val) =>
                                            this.props.onChange(
                                                val?.value,
                                                'howDidYouFindOutAboutUs'
                                            )
                                        }
                                        error={this.props.errors?.howDidYouFindOutAboutUs?.join(
                                            ', '
                                        )}
                                        required
                                        options={
                                            customerHowDidYouFindOutAboutUsOptions
                                        }
                                        inputType="select"
                                    /> */}
                                </>
                            )}
                        </>
                    )}

                    {this.renderCaptchaResponse() && (
                        <Alert
                            type="danger"
                            dismissible={false}
                            className="mt-4"
                            text={this.renderCaptchaResponse()}
                        />
                    )}

                    <div className="form-group d-flex justify-content-between">
                        <button
                            className="btn btn-dark btn-outline"
                            onClick={this.props.reset}
                            type="button">
                            Back to login
                        </button>

                        <button
                            type="submit"
                            className={`btn btn-primary ${this.props.loading ? 'btn-loading' : ''
                                }`}
                            disabled={this.props.loading}>
                            {this.props.loading ? (
                                <div className="loading-dots"></div>
                            ) : (
                                'Sign up'
                            )}
                        </button>
                    </div>

                    {(!this.props.type || this.props.type != 'chef') && (
                        <Input
                            id="newsletter-checkbox"
                            name="newsletter-checkbox"
                            inputType="checkbox"
                            isSelected={_.get(
                                this.props.formData,
                                'newsletter-checkbox',
                            )}
                            handleChange={(val) =>
                                this.props.onChange(val, 'newsletter-checkbox')
                            }
                            label="Keep me updated with special offers, exciting products and news from YHANGRY"
                        />
                    )}
                </form>
            </div>
        );
    }
}
